import script from "./MyCourses.vue?vue&type=script&setup=true&lang=js"
export * from "./MyCourses.vue?vue&type=script&setup=true&lang=js"

import "./MyCourses.vue?vue&type=style&index=0&id=b1c831e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1c831e2"]])

export default __exports__